<div>

    <!-- <app-notification-bar></app-notification-bar> -->
    <p *ngIf="clientCards">Total: {{clientCards.length}}</p>
    <mat-drawer-container class="example-container" autosize>
      <mat-drawer #drawer class="example-sidenav" mode="side">
        
        <button type="button" mat-button (click)="drawer.toggle()">
          <mat-icon>chevron_right</mat-icon>
        </button>
  
        <div>
          <div class="margin-bottom-1rem">
            <h4>Upcoming events</h4>
            <!-- <app-client-interactions></app-client-interactions> -->
            <button mat-mini-fab color="primary" (click)="openNewReminderModal()"><i class="fas fa-plus"></i></button>
          </div>
          
          <div class="margin-bottom-1rem">
            <h4>Web Contact Form</h4>
            <!-- <app-email-inbox></app-email-inbox> -->
          </div>
  
          <div>
            <h4>Funnel Form</h4>
            <!-- <app-funnels-inbox></app-funnels-inbox> -->
          </div>
        </div>
        
      </mat-drawer>
  
      <div class="example-sidenav-content">
        
        <div class='app'>
          <div>
            
            <!-- Top Bar -->
            <div class="flex top-bar">
              
              <!-- NO-MOBILE SIZE -->
              <!-- OTHER STATUS ---- LOST AND CASE STUDY -->
              <div *ngIf="!(vp.isMobile$ | async)">

                <button *ngIf="getTotalUnreadMessages()>0" type="button" mat-raised-button (click)="drawer.toggle()" matBadge="{{getTotalUnreadMessages()}}" matBadgePosition="before" matBadgeColor="warn">
                  <mat-icon>chevron_left</mat-icon>
                </button>
                <button *ngIf="getTotalUnreadMessages()==0" type="button" mat-raised-button (click)="drawer.toggle()">
                  <mat-icon>chevron_left</mat-icon>
                </button>

                <span *ngFor="let st of getNonVisibleStatus()" style="margin: 0 1rem;" >
                  <button mat-stroked-button class="margin-1rem" [matMenuTriggerFor]="menuCase" matBadge="{{getClientCardsByStatus(st.status).length}}" matBadgePosition="after" matBadgeColor="primary">{{st.status}}</button>
                  <mat-menu #menuCase="matMenu" >
                    <button mat-menu-item (click)="showColumn(st)"><i class="fas fa-columns"></i>Add column</button>
                    <button *ngFor="let clientCard of getClientCardsByStatus(st.status)" mat-menu-item>
                      {{clientCard.name}}  {{clientCard.lastname}}
                    </button>
                  </mat-menu>
                </span>  
              </div>
              
              <div class="menu-buttons">

                <!-- <button type="button" mat-icon-button color="primary" *ngIf="vp.isMobile$ | async" (click)="drawer.toggle()">
                  <mat-icon matBadge="{{getTotalUnreadMessages()}}" matBadgePosition="before" matBadgeColor="warn">
                    <i class="fas fa-inbox"></i>
                  </mat-icon>
                </button> -->

                <!-- <button type="button" mat-icon-button color="primary" (click)="openSearch()">
                  <mat-icon  matBadgePosition="before" matBadgeColor="warn">
                    <i class="fas fa-search"></i>
                  </mat-icon> 
                </button> -->

                <!-- FILTERS -->
                <!-- <button mat-button  color="primary" [matMenuTriggerFor]="filters"><i class="fas fa-sliders-h"></i></button>
                <mat-menu #filters="matMenu">
                  <button mat-menu-item [matMenuTriggerFor]="city">City
                    <mat-menu #city="matMenu">
                      <button mat-menu-item (click)="filterByCity('All')">All</button>
                      <button mat-menu-item (click)="filterByCity('Madrid')">Madrid</button>
                      <button mat-menu-item (click)="filterByCity('Barcelona')">Barcelona</button>
                      <button mat-menu-item (click)="filterByCity('Valencia')">Valencia</button>
                      <button mat-menu-item (click)="filterByCity('Murcia')">Murcia</button>
                      <button mat-menu-item (click)="filterByCity('Otra')">Otra</button>
                      <button mat-menu-item (click)="filterByCity('No definida')">No definida</button>
                    </mat-menu>
                  </button> -->
                  <!-- ASIGNEE -->
                  <!-- <button mat-menu-item [matMenuTriggerFor]="asignee">Asignee</button>
                  <mat-menu #filters="matMenu">
                    <button mat-menu-item [matMenuTriggerFor]="asignee">
                      <mat-menu #asignee="matMenu">
                        <button mat-menu-item (click)="filterByAsignee('All')">All</button>
                        <button mat-menu-item (click)="filterByAsignee('Sebas')">Sebas</button>
                        <button mat-menu-item (click)="filterByAsignee('Felipe')">Felipe</button>
                      </mat-menu>
                    </button>
                  </mat-menu>
                  
                </mat-menu> -->
  
                <button mat-icon-button  color="primary" (click)="reloadDashboardData()">
                  <mat-icon>sync</mat-icon>
                </button>
  
                <button mat-mini-fab class="margin-1rem" color="primary" (click)="goToPage('profile/new')">
                  <mat-icon>add</mat-icon>
                </button>
  
                <!-- ... dots -->
                <button mat-icon-button color="primary" [matMenuTriggerFor]="animals">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #animals="matMenu">
                  <button mat-menu-item  color="primary" [matMenuTriggerFor]="vertebrates">
                    <mat-icon><i class="fas fa-calendar"></i></mat-icon>
                    <span>Calendly</span>
                  </button>
                  <!--  <button mat-menu-item  color="primary" (click)="deleteCookies()">
                    <mat-icon><i class="fas fa-power-off"></i></mat-icon>
                    <span>Logout</span>
                  </button> -->
                </mat-menu>
  
                <!-- Calendly menu -->
                <mat-menu #vertebrates="matMenu">
                  <button mat-menu-item (click)="copyToCLipboard('https://calendly.com/voy-jaleas/30min?month=2023-02')">
                    <mat-icon>link</mat-icon>
                    <span>Book videocall link</span>
                  </button>
                  <button mat-menu-item>
                    <mat-icon>settings</mat-icon>
                    <span>Calendly</span>
                  </button>
                </mat-menu>  
              </div>
  
            </div>

            <!-- MOBILE SIZE -->
            <!-- Non visible status buttons for Mobile -->
            <mat-tab-group *ngIf="vp.isMobile$ | async">
              <mat-tab *ngFor="let st of getNonVisibleStatus()">
                <ng-template mat-tab-label class="custom">
                  <button mat-stroked-button class="margin-1rem"  [matMenuTriggerFor]="menuCase" matBadge="{{getClientCardsByStatus(st.status).length}}" matBadgePosition="after" matBadgeColor="primary">{{st.status}}</button>
                  <mat-menu #menuCase="matMenu" >
                    <button mat-menu-item (click)="showColumn(st)"><i class="fas fa-columns"></i>Add column</button>
                    <button *ngFor="let clientCard of getClientCardsByStatus(st.status)" mat-menu-item>
                      {{clientCard.name}}  {{clientCard.lastname}}
                    </button>
                  </mat-menu>
                </ng-template>
                <!-- Contenido -->
              </mat-tab>
            </mat-tab-group>
  
            <div class='project-tasks' style="display: inline-flex;overflow-x: scroll;">
      
              <!-- Columns -->
              <mat-spinner *ngIf="isLoading()"></mat-spinner>
              <div *ngFor="let st of getVisibleStatus()" >
                
                <div class='project-column' [id]="st.status" *ngIf="st.visible && !isLoading()">
                  <div class='project-column-heading'>
                    <h2 class='project-column-heading__title'>{{st.status}}</h2>
                    <span matBadge="{{getClientCardsByStatus(st.status).length}}" matBadgePosition="before" matBadgeColor="primary"></span>
                    <button mat-icon-button color="primary" [matMenuTriggerFor]="more" class='project-column-heading__options' aria-label="">
                      <mat-icon>more_horiz</mat-icon>
                    </button>
                  </div>
                  <!--  Card Menu -->
                  <mat-menu #more="matMenu">
                    <button mat-menu-item (click)="hideColumn(st)">Hide</button>
                  </mat-menu>
                
                  <!-- CARDS -->
                  <div class="flex-column">
                    <mat-accordion multi class="task" id="card-hover" draggable='true' id="{{generateHtmlId(clientCard)}}" (mouseover)="cardSelect(clientCard)" *ngFor="let clientCard of getClientCardsByStatus(st.status); let i=index">
      
                      <mat-expansion-panel>
                        <mat-expansion-panel-header>
                          <mat-panel-title [matTooltip]="'id:' + clientCard.id" class="client-name">
                            <span style="font-size: 10px;color: lightgray;margin: 0 5px;">({{clientCard.id}})</span> {{clientCard.name}} {{clientCard.lastname}}
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                    
                        <!-- CONTENIDO -->
                        <div class="flex-column gap-1rem">
                          <button mat-stroked-button color="primary"  (click)="goToUserProfile(clientCard)" aria-label="">
                            <i class="fas fa-user-circle"></i>
                            Profile
                          </button>
  
                          <span *ngIf="clientCard.career">
                            <i class="fas fa-user-graduate"></i>
                            {{clientCard.career}}
                          </span>
  
                          <span *ngIf="clientCard.university">
                            <i class="fas fa-university"></i>
                            {{clientCard.university}}
                          </span>
        
                          <span *ngIf="clientCard.goal">
                            <i class="fas fa-star"></i>
                            {{clientCard.goal}}
                          </span>
  
                          <span *ngIf="clientCard.address">
                            <i class="fas fa-fa-map-marker-alt"></i>
                            {{clientCard.address}}
                          </span>
  
                          <span *ngIf="clientCard.atEurope == 'yes'">
                            <i class="fas fa-globe-europe"></i>
                            {{clientCard.visitedCountries}}
                          </span>
  
                          <mat-divider *ngIf="clientCard.comments"></mat-divider>
                          <app-smart-paragraph *ngIf="clientCard.comments" [text]="clientCard.comments"  [limit]="125"></app-smart-paragraph>
  
                          <span *ngIf="clientCard.additionalInterests">
                            Otros intereses: 
                            {{clientCard.additionalInterests}}
                          </span>
  
                          <span *ngIf="clientCard.instagram">
                            <i class="fab fa-instagram"></i>
                            {{clientCard.instagram}}
                          </span>
  
                          <span *ngIf="clientCard.country">
                            {{clientCard.country}}
                          </span>
  
                          <app-smart-paragraph *ngIf="clientCard.notes" [text]="clientCard.notes"  [limit]="125"></app-smart-paragraph>
      
                        <!-- Package chosen -->
                        <div style="margin-top: 1rem" *ngIf="clientCard.FK_ID_package_chosen">
                          <span *ngIf="clientCard.pakName == 'Basic'" class='task__tag task__tag--illustration' (click)="openPackageDetailsSummary(clientCard.FK_ID_package_chosen)"><i class="fas fa-concierge-bell"></i>{{clientCard.pakName}} (${{clientCard.price}})</span>
                          <span *ngIf="clientCard.pakName == 'Premium'" class='task__tag task__tag--illustration' (click)="openPackageDetailsSummary(clientCard.FK_ID_package_chosen)"><i class="fas fa-bolt"></i>{{clientCard.pakName}} (${{clientCard.price}})</span>
                          <span *ngIf="clientCard.pakName == 'Full Assistance'" class='task__tag task__tag--illustration' (click)="openPackageDetailsSummary(clientCard.FK_ID_package_chosen)"><i class="fas fa-crown"></i>Full (${{clientCard.price}})</span>  
                        </div>
        
                        <!-- Progress bar -->
                        <div class="p2-small flex">
                          <progress class="progress-bar" max="100" value="{{clientCard.progress}}"></progress>
                          <span style="color: gray; font-size: 12px; font-weight: 600;">{{clientCard.progress}}%</span>
                        </div>
      
                        </div>
      
                        <div class="flex center">
                          <button mat-icon-button color="primary" aria-label="">
                            <mat-icon [matMenuTriggerFor]="dates">date_range</mat-icon>
                            <mat-menu #dates="matMenu">
                              <button mat-menu-item *ngIf="clientCard.firstContactDate"><i class="fas fa-comment"></i><app-date-render [date]="clientCard.firstContactDate" [format]="'short'"></app-date-render></button>
                              <button *ngIf="clientCard.dateFrom" mat-menu-item><i class="fas fa-plane-arrival"></i><app-date-render [date]="clientCard.dateFrom" [format]="'short'"></app-date-render></button>
                              <button mat-menu-item><i class="fas fa-graduation-cap"></i><app-date-render [date]="clientCard.startLessons" [format]="'short'"></app-date-render></button>
                              <button *ngIf="clientCard.dateTo" mat-menu-item><i class="fas fa-plane-departure"></i><app-date-render [date]="clientCard.dateTo" [format]="'short'"></app-date-render></button>
                            </mat-menu>
                          </button>
                          
                          <button mat-icon-button color="primary" (click)="goToUserDriveFolder(clientCard.driveUrl)" aria-label="">
                            <mat-icon *ngIf="!clientCard.driveUrl"><i class="fab fa-google-drive" style="color: lightgray"></i></mat-icon>
                            <mat-icon *ngIf="clientCard.driveUrl"><i class="fab fa-google-drive"></i></mat-icon>
                          </button>
        
                          <button mat-icon-button color="primary" (click)="copyToCLipboard(clientCard.email)" [matTooltip]="clientCard.email" aria-label="">
                            <mat-icon>email</mat-icon>
                          </button>
                        </div>
                    
                      </mat-expansion-panel>
      
                      <!-- SECOND ROW -->
                      <mat-expansion-panel (opened)="showLongHealthChip = true" (closed)="showLongHealthChip = false">
                        <!-- DESTINATION -->
                        <mat-expansion-panel-header id="middle-header">
                          <mat-chip-list>
                            <mat-chip  class='task__tag task__tag--copyright' style="font-size: 16px;" *ngIf="clientCard.serviceType">
                              <i *ngIf="clientCard.serviceType == 'Académico'" class="fas fa-graduation-cap"></i>
                              <i *ngIf="clientCard.serviceType == 'Alojamiento'" class="fas fa-home"></i>
                              <i *ngIf="clientCard.serviceType == 'Laboral'" class="fas fa-briefcase"></i>
                              <i *ngIf="clientCard.serviceType == 'Otro'" class="fas fa-info-circle"></i>
                              
                            </mat-chip>
  
                            <!-- SEGURO MEDICO -->
                            <mat-chip class='task__tag task__tag--design' *ngIf="clientCard.destination">{{clientCard.destination}}</mat-chip>
                            <mat-chip *ngIf="clientCard.endDate && getMonthsRemaining(null,clientCard.endDate)==0 && !showLongHealthChip">
                              <i class="fas fa-laptop-medical" style="color: red;font-size: 18px;"></i>
                            </mat-chip>
                            <mat-chip *ngIf="clientCard.endDate && getMonthsRemaining(null,clientCard.endDate)>0 && !showLongHealthChip">
                              <i class="fas fa-laptop-medical" style="font-size: 18px;"></i>
                            </mat-chip>
  
                            <mat-chip *ngIf="clientCard.legalService">
                              <i class="fas fa-balance-scale" style="font-size: 18px;"></i>
                            </mat-chip>
                          </mat-chip-list>
                        </mat-expansion-panel-header>
  
                        <!-- CONTENIDO -->
                        <mat-chip-list *ngIf="clientCard.endDate && showLongHealthChip">
                          <mat-chip *ngIf="getMonthsRemaining(null,clientCard.endDate)>3"><i class="fas fa-laptop-medical"></i>{{getMonthsRemaining(null,clientCard.endDate)}} meses</mat-chip>
                          <mat-chip *ngIf="getMonthsRemaining(null,clientCard.endDate)<=3 && getMonthsRemaining(null,clientCard.endDate)>0" color="accent"><i class="fas fa-laptop-medical"></i>{{getMonthsRemaining(null,clientCard.endDate)}} meses</mat-chip>
                          <mat-chip *ngIf="getMonthsRemaining(null,clientCard.endDate)==0"><i class="fas fa-laptop-medical"></i>Vencido</mat-chip>
                        </mat-chip-list>
  
                        <div class="flex-column">
  
                          <span *ngIf="clientCard.how">Nos conoció vía:<app-smart-paragraph [text]="clientCard.how"  [limit]="125"></app-smart-paragraph></span>
                          <div class="flex">
                            <app-date-render style="font-size: 12px; color: gray" [date]="clientCard.lastUpdatedAt" [format]="'short'"></app-date-render>
                          </div>
                        </div>
      
                      </mat-expansion-panel>
  
                      <!-- THIRD ROW -->
                      <mat-expansion-panel disabled>
                        <!-- DESTINATION -->
                        <mat-expansion-panel-header id="summary-header">
                          <mat-chip-list>
                            <!-- Assignee -->
                            <mat-chip *ngIf="clientCard.assignee" [matMenuTriggerFor]="menuAssignees" class='task__tag task__tag--illustration'>
                              <mat-icon style="font-size: 16px;"><i class="fas fa-user-tie"></i></mat-icon>
                              {{clientCard.assignee}}
                              </mat-chip>
                            <mat-menu #menuAssignees="matMenu">
                              <button mat-menu-item (click)="changeAssignee(clientCard.assignee,clientCard.followUpId)">
                                <mat-icon><i class="fas fa-user-tie"></i></mat-icon>
                                <span *ngIf="clientCard.assignee == 'Sebas'">Felipe</span>
                                <span *ngIf="clientCard.assignee == 'Felipe'">Sebas</span>
                              </button>
                            </mat-menu>
                            <!-- DAYS SINCE LAST INTERACTION -->
                            <mat-chip class='task__tag task__tag--illustration' *ngIf="showLastContact(clientCard.lastInteractionDate) && getLastContactDays(clientCard.lastInteractionDate)<15">{{getLastContactDays(clientCard.lastInteractionDate)}} days</mat-chip>
                            <mat-chip class='task__tag task__tag--warning' *ngIf="showLastContact(clientCard.lastInteractionDate) && getLastContactDays(clientCard.lastInteractionDate)>15 && getLastContactDays(clientCard.lastInteractionDate)<30">
                              <i class="fas fa-exclamation-triangle" style="margin-right: 5px;"></i>
                              {{getLastContactDays(clientCard.lastInteractionDate)}} days
                            </mat-chip>
                            <mat-chip class='task__tag task__tag--attention' *ngIf="showLastContact(clientCard.lastInteractionDate) && getLastContactDays(clientCard.lastInteractionDate)>15">
                              <i class="fas fa-exclamation-circle" style="margin-right: 5px;"></i>
                              {{getLastContactDays(clientCard.lastInteractionDate)}} days
                            </mat-chip>
                          </mat-chip-list>
                        </mat-expansion-panel-header>  
                      </mat-expansion-panel>
                    
                      <!-- FOURTH ROW -->
                      <mat-expansion-panel disabled>
                        <mat-expansion-panel-header>
                          <div class='task__stats'>
                          
                            <button mat-icon-button color="primary" (click)="getClientData(clientCard)" aria-label="">
                              <mat-icon>account_circle</mat-icon>
                            </button>
      
                            <button mat-icon-button color="primary" (click)="openDialog(clientCard)" aria-label="">
                              <mat-icon>comment</mat-icon>
                            </button>
          
                            <button  mat-icon-button color="primary" [matMenuTriggerFor]="menu">
                              <mat-icon>more_horiz</mat-icon>
                              <mat-menu #menu="matMenu">
                                  <button mat-menu-item  [matMenuTriggerFor]="subMenuStatus"><i class="fas fa-columns"></i>Move to
                                    <mat-menu #subMenuStatus="matMenu">
                                      <button mat-menu-item *ngFor="let stat of statusArray" (click)="changeStatusTo(stat.status,clientCard)">
                                        <i [class]="stat.icon"></i>
                                        {{stat.status}}
                                      </button>
                                    </mat-menu>
                                  </button>
                                  <!-- DELETE -->
                                  <button mat-menu-item  [matMenuTriggerFor]="asignee"><i class="fas fa-user"></i>Asign to
                                    <mat-menu #asignee="matMenu">
                                      <button mat-menu-item  (click)="delete(clientCard)">
                                        <i class="fas fa-user"></i>
                                        Sebas
                                      </button>
                                      <button mat-menu-item  (click)="delete(clientCard)">
                                        <i class="fas fa-user"></i>
                                        Felipe
                                      </button>
                                    </mat-menu>
                                  </button>
                                  <button mat-menu-item *ngIf="clientCard.username">
                                    <i class="fas fa-user-circle"></i>{{clientCard.username}}
                                  </button>
                                  <!-- Create a user session -->
                                  <button mat-menu-item (click)="newSession(clientCard)" *ngIf="!clientCard.username">
                                    <mat-icon>apps</mat-icon>Create User Session
                                  </button>
                                  <button mat-menu-item *ngIf="clientCard.username">
                                    <i class="fas fa-user-circle"></i>{{clientCard.username}}
                                  </button>
                                  <!-- DELETE -->
                                  <button mat-menu-item  [matMenuTriggerFor]="deleteMenu"><i class="fas fa-trash"></i>Delete
                                    <mat-menu #deleteMenu="matMenu">
                                      <button mat-menu-item  (click)="delete(clientCard)">
                                        <i class="fas fa-trash"></i>
                                        Confirm delete
                                      </button>
                                    </mat-menu>
                                  </button>
                                </mat-menu>
                              
                            </button>
          
                          </div>
                        </mat-expansion-panel-header>
                        
                        <!-- CONTENIDO -->
        
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
      
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
    </mat-drawer-container>
  
    <mat-toolbar>
      <span> © | VoyJaleas | All rights reserved.</span>
    </mat-toolbar>
  </div>
  
  
  
    <!-- // MAIN VIEW OF CARDS
  SELECT * FROM `clientFollowUp` cf
  INNER JOIN `clientDetails` cd ON
  cf.FK_ID_clientDetails = cd.id
  
  
  SELECT * FROM `clientFollowUp` cf
  INNER JOIN `clientDetails` cd ON
  cf.FK_ID_clientDetails = cd.id
  LEFT JOIN `plan`pl ON
  cd.id = pl.FK_ID_clientDetails
  
  
  SELECT cf.status,cf.progress,cd.name,cd.lastname,cd.lastname2,cd.goal,cd.destination,cd.university,cd.email,cd.driveUrl,cd.dateFrom,cd.dateTo,pl.paid,pak.name as packName,pak.price,pak.currency
  FROM `clientFollowUp` cf
  INNER JOIN `clientDetails` cd ON
  cf.FK_ID_clientDetails = cd.id
  LEFT JOIN `plan` pl ON
  cd.id = pl.FK_ID_clientDetails
  LEFT JOIN `package` pak ON
  pak.id = pl.FK_ID_package_chosen
  
  
  SELECT cf.status,cf.progress,cd.name,cd.lastname,cd.lastname2,cd.goal,cd.destination,cd.university,cd.email,cd.driveUrl,cd.dateFrom,cd.dateTo,pl.paid,pak.name,pak.price,pak.currency
  FROM `clientFollowUp` cf
  INNER JOIN `clientDetails` cd ON
  cf.FK_ID_clientDetails = cd.id
  INNER JOIN `plan` pl ON
  cd.id = pl.FK_ID_clientDetails
  INNER JOIN `package` pak ON
  pak.id = pl.FK_ID_package_chosen -->
  
  
  <!-- SELECT * FROM `package` pak
  INNER JOIN `productXpackage` pp ON
  pak.id = pp.FK_ID_package
  INNER JOIN `product` pro ON
  pro.id = pp.FK_ID_product
  WHERE pak.id = '10' -->
  
  
  
  
  
